var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import TRANSLATIONS_EN from "./en.json";
import TRANSLATIONS_ES from "./es.json";
import TRANSLATIONS_POR from "./por.json";
import TRANSLATIONS_AR from "./ar.json";
import TRANSLATIONS_FR from "./fr.json";
import TRANSLATIONS_JP from "./ja.json";
import moment from "moment";
// Import the locales you actually support
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/ar";
import "moment/locale/fr";
import "moment/locale/ja";
var loadChildTranslations = function () { return __awaiter(void 0, void 0, void 0, function () {
    var importTranslations, translations, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, import("adrinWebApp/Translations")];
            case 1:
                importTranslations = (_a.sent()).default;
                return [4 /*yield*/, importTranslations()];
            case 2:
                translations = _a.sent();
                console.log("Loaded child translations:", translations);
                return [2 /*return*/, translations];
            case 3:
                error_1 = _a.sent();
                console.error("Error loading translations from child app:", error_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: "en",
    load: "currentOnly",
    resources: {
        en: {
            translation: TRANSLATIONS_EN,
        },
        es: {
            translation: TRANSLATIONS_ES,
        },
        pt: {
            translation: TRANSLATIONS_POR,
        },
        ar: {
            translation: TRANSLATIONS_AR,
        },
        fr: {
            translation: TRANSLATIONS_FR,
        },
        ja: {
            translation: TRANSLATIONS_JP,
        },
    },
    interpolation: {
        escapeValue: false,
    },
});
loadChildTranslations().then(function (childTranslations) {
    if (childTranslations) {
        console.log(childTranslations, 'child translations');
        Object.entries(childTranslations).forEach(function (_a) {
            var lang = _a[0], translation = _a[1];
            i18n.addResourceBundle(lang, "translation", translation, true, true);
        });
    }
    else {
        console.warn("Child translations are not available.");
    }
});
moment.locale(i18n.language || "en");
// Keep moment in sync when language changes
i18n.on("languageChanged", function (lng) {
    moment.locale(lng || "en");
});
export default i18n;
